import { styled } from '@mui/material';

const PREFIX = 'BreakpointAnalysis';

export const classes = {
  useCustomBreakpoints: `${PREFIX}-useCustomBreakpoints`,
  switchToggleLegend: `${PREFIX}-switchToggleLegend`,
};

export const Root = styled('div')(() => ({
  [`& .${classes.useCustomBreakpoints}`]: {
    paddingBottom: '1.5rem',
  },

  [`& .${classes.switchToggleLegend}`]: {
    fontWeight: 'bold',
  },
}));
